<template>
	<table class="table-main">
		<thead>
			<tr>
				<th v-text="'#'" />
				<th v-text="'클라이언트'" />
				<th v-text="'이벤트명'" />
				<th v-text="'이벤트ID'" />
				<th v-text="'이벤트 시작일시'" />
				<th v-text="'참여일시'" />
			</tr>
		</thead>
		<tbody>
			<tr v-for="(item, idx) in list" :key="item.idEvent">
				<td v-text="idx + 1" />
				<td v-text="item.clientName" />
				<td v-text="item.eventTitle" />
				<td v-text="item.idEvent" />
				<td v-text="dateFormat(item.startDate)" />
				<td v-text="dateFormat(item.endDate)" />
			</tr>
		</tbody>
	</table>
</template>
<script>
	import filters from '@/filters.js';

	export default {
		name: 'EventWinnerHistoryList',
		data() {
			return {
				idRegister: this.$store.state.modal.params.idRegister,
				list: [],
				dateFormat: filters.dateFormat,
			};
		},
		methods: {
			async setTable() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/v3/api/stamp/win-history/${this.idRegister}`
					);
					this.list = data;
				} catch (e) {
					console.error(e);
					alert('당첨이력을 불러오는데 실패했습니다.');
				}
			},
		},
		mounted() {
			this.setTable();
		},
	};
</script>
